<template>
  <v-container fluid>
    <Keyboard v-model="keyboard" layout="compact" />
    <v-row no-gutters>
      <v-col>
        <v-select
          rounded
          :items="data"
          outlined
          item-text="strNombre"
          item-value="intPOSTipoVenta"
          label="Tipo Venta"
          v-model="localValue.tipo"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <v-text-field
          rounded
          :readonly="disabled"
          v-model="localValue.clave"
          label="Clave"
          outlined
          @click="showKeyboard($event)"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- <v-row no-gutters>
      <v-col>
        <v-text-field
          rounded
          v-model="localValue.telefono"
          label="Telefono"
          outlined
        ></v-text-field>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import { Session,Data } from "../controllers/DataController.js";
import Keyboard from "./Keyboard.vue";
export default {
  props: {
    value: {
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Keyboard,
  },
  data() {
    return {
      dataController: new Data(),
      localValue: this.value,
      keyboardSession: false,
      keyboard: {
        visible: false,
        input: null,
      },
      venta:this.data
    };
  },
  methods: {
    showKeyboard(e) {
      if (this.keyboardSession && !this.disabled) {
        this.keyboard.input = e.target;
        this.keyboard.visible = true;
      }
    },
  },
  async mounted() {
    this.keyboardSession = new Session().keyboard;
    console.log("entra",this.localValue.tipo)

    let tipoventas = await this.dataController.loadTipoVentas();
    console.log(tipoventas)
    console.log(this.venta)
        //  tipoventas.forEach((x) => this.tipoventas.push(x));
          // tipoventas.forEach(async (x) => { await db.tiposVenta.add(x)})

  },
  watch: {
    localValue(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      this.localValue = newValue;
    },
  },
};
</script>

<style></style>
